import React, { useEffect, useState } from "react";
import {
  Phase,
  getAllPhases,
} from "../onboarding/utils/onboardingHelpers";

interface OnboardingSidebarProps {
  userType: "learner" | "facilitator" | "guardian";
  sectionId: string;
  completedSteps: string[];
  onPhaseChange: (phase: Phase | null) => void;
}
const defaultIcon = <i className="far fa-eye nav-item-icon" aria-hidden="true"></i>;

const OnboardingSidebar: React.FC<OnboardingSidebarProps> = ({
  userType,
  sectionId,
  completedSteps,
  onPhaseChange
}) => {

  const [allPhases, setAllPhases] = useState<Phase[]>([]);
  const [completedPhases, setCompletedPhases] = useState<Phase[]>([]);
  const [currentPhase, setCurrentPhase] = useState<Phase | null>(null);


  useEffect(() => {
    const phases = getAllPhases(userType.toLowerCase(), completedSteps);

    setAllPhases(phases)

    setCompletedPhases(phases.filter((phase) => phase.completed));

    const current = phases.find((phase) => phase.steps.includes(sectionId));

    if (current) {
      const stepIndex = current.steps.indexOf(sectionId);
      const phaseWithStep = {
        ...current,
        stepNumber: stepIndex + 1,
      };
      setCurrentPhase(phaseWithStep);
      onPhaseChange(phaseWithStep);
    } else {
      setCurrentPhase(null);
      onPhaseChange(null);
    }
  }, [sectionId, completedSteps, userType]);

  if (allPhases.length === 0) {
    return null
  }

  if (sectionId === "signup") {
    return null
  }

  return (
    <div className="side-bar-nav onboarding-nav">
      {allPhases.map((phase) => {
        const isActive = phase.key === currentPhase?.key;
        const activeClass = isActive ? 'nav-link-active' : ''
        
        const icon = phase.completed ? (
          <i className="fas fa-check-circle nav-item-icon completed" aria-hidden="true"></i>
        ) : phase.iconLink ? (
          <img
            className="nav-item-icon"
            src={phase.iconLink}
            alt={`${phase.title} icon`}
            style={{ width: 20, height: 20, objectFit: "contain" }}
          />
        ) : phase.icon ? (
          <i className={`nav-item-icon ${phase.icon}`}></i>
        ) : (
          defaultIcon
        );

        return (
          <div
            key={phase.key}
            className={`nav-item ${phase.completed ? "opacity" : ""}`}
          >
            <div
              className={`nav-link ${activeClass}`}
            >
              {icon}
              <div style={{ textAlign: 'left', display: 'flex', flexDirection: 'column', justifyContent: 'flex-start' }}>
                <span>{phase.title}</span>
                <span
                  style={{
                    fontSize: "0.9rem",
                    color: "rgba(255, 255, 255, 0.7)",
                    fontWeight: "normal"
                  }}
                >
                  {phase.subtitle}
                </span>
              </div>
            </div>
          </div>
        );
      })}
    </div>
  );
};

export default OnboardingSidebar;